function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "COM-4258",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "corporate_fare_black"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,4.66666667 L8,2 L1.33333333,2 L1.33333333,14 L14.6666667,14 L14.6666667,4.66666667 L8,4.66666667 Z M6.66666667,12.6666667 L2.66666667,12.6666667 L2.66666667,11.3333333 L6.66666667,11.3333333 L6.66666667,12.6666667 Z M6.66666667,10 L2.66666667,10 L2.66666667,8.66666667 L6.66666667,8.66666667 L6.66666667,10 Z M6.66666667,7.33333333 L2.66666667,7.33333333 L2.66666667,6 L6.66666667,6 L6.66666667,7.33333333 Z M6.66666667,4.66666667 L2.66666667,4.66666667 L2.66666667,3.33333333 L6.66666667,3.33333333 L6.66666667,4.66666667 Z M13.3333333,12.6666667 L8,12.6666667 L8,6 L13.3333333,6 L13.3333333,12.6666667 Z M12,7.33333333 L9.33333333,7.33333333 L9.33333333,8.66666667 L12,8.66666667 L12,7.33333333 Z M12,10 L9.33333333,10 L9.33333333,11.3333333 L12,11.3333333 L12,10 Z",
  id: "Shape",
  fill: "#0AA6A8",
  fillRule: "nonzero"
})));

function SvgCorporateFareBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "corporate_fare_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFareBlack);
export default __webpack_public_path__ + "static/media/corporate_fare_black.f9064a9e.svg";
export { ForwardRef as ReactComponent };